/* «Улучшить» описания «Фото» и «Видео»: кнопка и варианты; правила запроса — сессия engine-kit/improve-service.ts (ключ до POST, GET того же
   ключа после ACK, 404-повтор, 422 освобождает намерение), общая с движком шаблона (BotText.improveInline). */
import { useEffect, useState } from 'react';
import { uiText } from '../../i18n';
import { createImproveSession, improveExpired, improvePending } from '../studio/engine-kit/improve-service';
import { StudioIcon } from '../studio/StudioIcon';

/** Неизвестный запрос восстанавливается по UUID; автоматического повторного POST нет. */
export function PhotoImprove({
  kind = 'photo',
  ...props
}: {
  text: string;
  onPick(text: string): void;
  disabled: boolean;
  kind?: 'photo' | 'video';
}) {
  return <Improve key={kind} kind={kind} {...props} />;
}
function Improve({
  text,
  onPick,
  disabled,
  kind,
}: {
  text: string;
  onPick(text: string): void;
  disabled: boolean;
  kind: 'photo' | 'video';
}) {
  const [session] = useState(() => createImproveSession(kind));
  const [state, setState] = useState(session.get);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const off = session.subscribe(setState);
    void session.start();
    return () => {
      off();
      session.stop();
    };
  }, [session]);
  const { owner, intent, busy, error, replayAllowed, blocked } = state;
  const execute = (readOnly: boolean) => void session.execute(readOnly, text);
  const pending = improvePending(intent);
  const expired = improveExpired(intent, now);
  return (
    <div className="photo-improve">
      <button
        type="button"
        className="bci-b"
        disabled={disabled || busy || !owner || !!pending || !text.trim() || Array.from(text).length > 500 || blocked}
        onClick={() => execute(false)}
      >
        <StudioIcon />
        {uiText(busy ? 'Проверяем…' : 'Улучшить')}
      </button>
      {pending && !expired && (
        <button type="button" disabled={busy || disabled} onClick={() => execute(true)}>
          {uiText('Проверить улучшение')}
        </button>
      )}
      {pending && replayAllowed && !expired && (
        <button type="button" disabled={busy || disabled} onClick={() => execute(false)}>
          {uiText('Повторить прежнее улучшение')}
        </button>
      )}
      {expired && (
        <p>
          {uiText('Срок проверки улучшения истёк. Исходный текст сохранён.')}{' '}
          <button type="button" disabled={busy || disabled} onClick={() => session.reset()}>
            {uiText('Начать новое улучшение')}
          </button>
        </p>
      )}
      {error && <p role="alert">{uiText(error)}</p>}
      {intent?.result?.status === 'done' && (
        <div>
          {intent.result.variants.map((value, index) => (
            <button type="button" key={index} disabled={disabled} onClick={() => onPick(value)}>
              {value}
            </button>
          ))}
        </div>
      )}
      {intent?.result?.status === 'rejected' && <p>{uiText('Текст отклонён проверкой. Измените текст.')}</p>}
      {intent?.result?.status === 'failed' && <p>{uiText('Не удалось улучшить текст. Исходный текст сохранён.')}</p>}
    </div>
  );
}
